import { render, staticRenderFns } from "./UpdateVersion.vue?vue&type=template&id=12388c4c"
import script from "./UpdateVersion.vue?vue&type=script&lang=ts"
export * from "./UpdateVersion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports